import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ApiError,
  CreateMessage,
  FindManyMessageThreads,
  Message,
  MessageThread,
  PaginateResult,
} from '@univacity/shared/types';

// export const initMessages = createAction('[Messages Page] Init');

// export const loadMessagesSuccess = createAction(
//   '[Messages/API] Load Messages Success',
//   props<{ messages: MessagesEntity[] }>()
// );

// export const loadMessagesFailure = createAction(
//   '[Messages/API] Load Messages Failure',
//   props<{ error: any }>()
// );

export const MessagesActions = createActionGroup({
  source: 'Message Page',
  events: {
    'Fetch Threads': props<{ query?: FindManyMessageThreads }>(),
    'Fetch Threads Success': props<{
      res: PaginateResult<MessageThread>;
    }>(),
    'Fetch Threads Failure': props<{
      error?: ApiError;
    }>(),

    'Fetch Unread Messages Count': props<{ thread: string }>(),
    'Fetch Unread Messages Count Success': props<{
      count: number;
      thread: string;
    }>(),
    'Fetch Unread Messages Count Failure': props<{ error?: ApiError }>(),

    'Fetch all Unread Messages Count': emptyProps(),
    'Fetch all Unread Messages Count Success': props<{ count: number }>(),
    'Fetch all Unread Messages Count Failure': props<{ error?: ApiError }>(),

    'Fetch Messages': props<{ thread: string }>(),
    'Fetch Messages Success': props<{
      res: PaginateResult<Message>;
      thread: string;
    }>(),
    'Fetch Messages Failure': props<{ error?: ApiError }>(),

    'Send Message': props<{ thread: string; message: CreateMessage }>(),
    'Send Message Success': props<{ message: Message }>(),
    'Send Message Failure': props<{ error?: ApiError }>(),

    'Load More Messages': emptyProps(),
    'Load More Messages Empty': emptyProps(),
    'Select Thread': props<{ thread?: string | null }>(),
  },
});
